const concatenarArray = (val, stringConcat = ', ') => {
  if (Array.isArray(val)) {
    return val.join(stringConcat)
  }
  return val
}

export {
  concatenarArray
}